module.exports = __webpack_public_path__ + "img/pic_0.7593f343.webp";